import { TimelineMax, Expo } from 'gsap';

const LiveImage = (element) => {
  const picture = element;

  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start')
    .to(picture, 1, {
      yPercent: 0,
      scaleY: 1,
      autoAlpha: 1,
      // rotation: 0,
      transformOrigin: '50% 0px',
      ease: Expo.easeInOut,
    }, 'start');
  return tl;
};

export default LiveImage;
